<template>
    <div class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    {{ $t("confirm-remove-note.title") }}
                </p>
                <button class="delete" @click="close"></button>
            </header>
            <section class="modal-card-body">
                <div>
                    <p>{{ $t("confirm-remove-note.body") }}</p>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button
                    class="button is-danger"
                    :class="{ 'is-loading': removing }"
                    @click="removeNote"
                >
                    {{ $t("confirm-remove-note.remove") }}
                </button>
                <button class="button" @click="close">
                    {{ $t("confirm-remove-note.cancel") }}
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import { RepositoryFactory } from "@/services/api";

export default {
    name: "confirm-remove-note-modal",
    props: {
        noteId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            removing: false,
        };
    },
    methods: {
        ...mapActions("notes", ["deleteNote"]),
        close() {
            this.$emit("close");
        },
        async removeNote() {
            this.removing = true;
            try {
                await RepositoryFactory.notes.deleteNote({
                    noteId: this.noteId,
                });
                this.deleteNote(this.noteId);
                this.close();
            } catch (error) {
                window.console.log(error);
            }
            this.removing = false;
        },
    },
};
</script>